import React, { Component } from "react";
import "./CheckInput.less";

class CheckInput extends Component {
  render() {
    const { name, checked, onChange, label } = this.props;

    return (
      <label className="check-input">
        <input type="checkbox" name={name} checked={checked} onChange={onChange} />
        <span className="check-input__box"></span>
        {label}
      </label>
    );
  }
}

export default CheckInput;
